import { Component } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { SessionService } from 'libs/shared/src/lib/service/session.service';

@Component({
  selector: 'piqet-angular-additional-info-news',
  templateUrl: './additional-info-news.component.html',
  styleUrls: ['./additional-info-news.component.scss'],
})
export class AdditionalInfoNewsComponent {
  private bc = new BroadcastChannel('session_channel');
  private tabId: string = Math.random().toString(36).substring(2, 15);

  newsList: any;
  isFromDashboard: any = false;
  constructor(
    private modal: CustomModalService,
    private adminService: AdministratorService,
    private sessionService: SessionService
  ) {
    this.newsList = this.modal?.modalService?.config?.initialState?.['item'];
    this.isFromDashboard = this.modal?.modalService?.config?.initialState?.['isFromDashboard'];
  }

  onClose() {
    this.modal.close();
    this.bc.postMessage({
      type: 'closeNewsModels',
      tabId: this.tabId,
      timestamp: Date.now(),
    });
    if (!this.isFromDashboard) {
      this.adminService.updateUserNewsNotification(this.newsList?.id).subscribe(() => {});
    }
  }
}
